<template>
  <el-form ref="addressForm" :model="currentAddress" :rules="rules" v-if="show">

    <el-row :gutter="20">
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-form-item :label="$t('common.addresses.AddressType')" prop="type">
          <el-select
            v-model="currentAddress.type"
            filterable
            value-key="id">
            <el-option
              v-for="item in addressType"
              :key="item.id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-if="currentAddress.type!=null && (currentAddress.type.code=='ADMIN' || currentAddress.type.code=='PICKING')">
          <el-form-item :label="$t('common.addresses.IdentificationCode')">
            <el-input v-model="currentAddress.code"></el-input>
          </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-form-item :label="$t('common.addresses.Address')">
          <el-input v-model="currentAddress.street" :placeholder="$t('common.addresses.Address')"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-form-item :label="$t('common.addresses.City')">
          <el-input v-model="currentAddress.city" :placeholder="$t('common.addresses.City')"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-form-item :label="$t('common.addresses.PostalCode')">
          <el-input v-model="currentAddress.postal_code" :placeholder="$t('common.addresses.PostalCode')"></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-form-item  prop="country" :label="$t('common.addresses.Country')">
          <el-select
            v-model="currentAddress.country"
            filterable
            :placeholder="$t('common.addresses.Country')"
            @change="getStates(currentAddress.country.id)"
            value-key="id">
            <el-option
              v-for="item in countries"
              :key="item.id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-form-item :label="$t('common.addresses.State')" v-if="(this.currentAddress.country==null || this.currentAddress.country!=null && this.currentAddress.country.id<3)">
          <el-select
            v-model="currentAddress.state"
            filterable
            :disabled="currentAddress.country==null"
            value-key="id">
            <el-option
              v-for="item in states"
              :key="item.id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
        <el-form-item :label="$t('common.addresses.State')" v-if="currentAddress.country!=null && currentAddress.country.id>2">
          <el-input  v-model="currentAddress.other_state"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row type="flex" justify="end">
      <el-col>
        <el-button @click="cancel">{{$t('common.cancel')}}</el-button>
        <el-button @click="addAddress" v-if="!editionMode" type="primary">{{$t('common.Add')}}</el-button>
        <el-button @click="editAddress" v-if="editionMode" type="primary">{{$t('common.Edit')}}</el-button>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import axios from "axios"
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
	name: 'AddressForm',
	props: {
    addressToEdit : Object,
    show : Boolean,
	},
  watch : {
    show : function(val){
      this.open();
    }
  },
	data() {
		return {
        existingAdresses : [],
        currentAddress:{
          street : null,
          city : null,
          state : null,
          country : null,
          code : null,
          other_state : null,
          postal_code : null,
          type : null
        },
        states : [],
        editionMode : false,
        rules :{
  				country : [
  	  		 	{ required: true, message: 'Veuillez sélectionner un pays', trigger: 'blur' }
  	  		],
          type : [
  	  		 	{ required: true, message: "Veuillez choisir un type d'addresse", trigger: 'blur' }
  	  		]
        },
        addressType : [{id:1,name:"Facturation"},{id:2,name:"Livraison"},{id:3,name:"Principale"}, {id:4,name:"Correspondance"},{id:5,name:"Administrative", code : "ADMIN"}, {id:6,name:"Enlèvement", code:"PICKING"}],
		}

	},
	computed : {
    ...mapState('controlData',['countries'])
     },
	methods : {
    getStates(country_id){
      if(country_id>2)this.currentAddress.state= null;
			axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/address/states?countryId="+country_id)
				.then(response=>{
					this.states = response.data;
				}).catch(err=>{
					// console.log(err);
				})
		},
    cancel(){
      this.$emit('cancel');
    },
    addAddress(){
      this.$refs['addressForm'].validate((valid)=>{
        if(valid){
          this.$emit('add',this.currentAddress);
          }
      });
    },
    editAddress(){
      this.$refs['addressForm'].validate((valid)=>{
        if(valid){
          this.$emit('change',this.currentAddress);
          }
      });
    },
    open(){
      if(this.addressToEdit!=null){
        //Mode edition
        this.editionMode = true;
        this.currentAddress = _.cloneDeep(this.addressToEdit);
        if(this.currentAddress.country!=null && this.currentAddress.country.id<3){
          this.getStates(this.currentAddress.country.id);
        }
      }else{
        //Mode Création
        this.currentAddress = {};
        this.editionMode = false;
      }
    },
    ...mapActions('controlData',['fetchCountries'])
	},
  created(){
    this.fetchCountries();
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables';

.el-select{
	width:100%;
}



</style>
